"use strict";
exports.__esModule = true;
exports.PlatformProducerOrderProductionPlanBuilder = void 0;
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var PlatformProducerOrderProductionPlanBuilder = /** @class */ (function () {
    function PlatformProducerOrderProductionPlanBuilder(orderPlan) {
        this.orderPlan = orderPlan;
    }
    PlatformProducerOrderProductionPlanBuilder.initialiseWithPlatformProducerOrderProductionPlan = function (orderPlan) {
        return new PlatformProducerOrderProductionPlanBuilder(orderPlan);
    };
    PlatformProducerOrderProductionPlanBuilder.initialiseWithPlatformMerchantOrderItemProductionPlans = function (platformProducerOrderId, itemPlans) {
        var items = [];
        for (var _i = 0, _a = Array.from(itemPlans.keys()); _i < _a.length; _i++) {
            var platformMerchantOrderItemId = _a[_i];
            items.push({
                id: core_common_logic_1.CommonLogic.generateUUIDv4(),
                platformProducerOrderItemId: platformMerchantOrderItemId,
                productionPlan: itemPlans.get(platformMerchantOrderItemId)
            });
        }
        return PlatformProducerOrderProductionPlanBuilder.initialiseWithPlatformProducerOrderProductionPlan({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            platformProducerOrderId: platformProducerOrderId,
            items: items,
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    PlatformProducerOrderProductionPlanBuilder.prototype.getId = function () {
        return this.orderPlan.id;
    };
    PlatformProducerOrderProductionPlanBuilder.prototype.withId = function (id) {
        this.orderPlan.id = id;
        return this;
    };
    PlatformProducerOrderProductionPlanBuilder.prototype.build = function () {
        return this.orderPlan;
    };
    PlatformProducerOrderProductionPlanBuilder.prototype.buildUpdate = function () {
        return {
            platformProducerOrderId: this.orderPlan.platformProducerOrderId,
            items: this.orderPlan.items
        };
    };
    return PlatformProducerOrderProductionPlanBuilder;
}());
exports.PlatformProducerOrderProductionPlanBuilder = PlatformProducerOrderProductionPlanBuilder;
